"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  Component,
  PropSync,
  Ref,
  Mixins,
  Watch
} from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import {
  BindShopProFormModel
} from "@/models/formModels/BindShopForm.model";
import { UiFormAnnotations } from "@/components/form/annotations";
import Question from "@/components/Question.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import ShopPlatforms from "@/views/virtualdesktopItems/components/dialog-forms/ShopPlatforms.vue";
import ShopChooseUsers from "@/views/bindItems/ShopChooseUsers.vue";
import i18n from "@/lang";
import UploadEnclosure from "./UploadEnclosure.vue";
import taskMap from "@/configuration/taskMap";
import iconMap from "@/utils/iconMap";
import UploadEnclosureBottom from "./UploadEnclosureBottom.vue";
import { Transform } from "@/utils/fileSize";
import { PaymentComputerConfigModel } from "@/models/paymentModels/paymentNewComputerConfig.model";
import RSAEncryptUtil from "@/configuration/rsa";
import CryptoJS from "crypto-js";
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import AddVisitDialog from "@/views/shopItems/components/AddVisitDialog.vue";
import ConfigTOTPDialog from "@/views/virtualdesktopItems/components/dialog-forms/ConfigTOTPDialog.vue";
import EditTOTPNameDialog from "@/views/virtualdesktopItems/components/dialog-forms/EditTOTPNameDialog.vue";
import AddTOTPDialog from "@/views/virtualdesktopItems/components/dialog-forms/AddTOTPDialog.vue";
import BindTOTPByListDialog from "@/views/virtualdesktopItems/components/dialog-forms/BindTOTPByListDialog.vue";
import TOTPBlackListDialog from "@/views/virtualdesktopItems/components/dialog-forms/TOTPBlackListDialog.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
export class VirtualdesktopFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.platform_style = "";
    this.platform_id = "";
    this.shop_url = "";
    this.shop_lock_num = 1;
    this.mode = "";
    this.useragent = "";
    this.mac_useragent = "";
    this.win_useragent = "";
    this.linux_useragent = "";
    this.android_useragent = "";
    this.resolution_mode = "";
    this.browser_core = "";
    this.user_ids = [];
    this.screen = "";
    this.resolution = "";
    this.shop_lock = false;
    this.sub_platforms = [];
    this.company_name = "";
    this.create_env_setting = false;
    this.lock_account = false;
    this.choose_user = "";
    this.third_party_cookie_auth = false;
    this.totp_data = null;
    this.blacklist = null;
    this.name = "";
    this.account = "";
    this.password = "";
    this.ui_language = "zh-CN";
    // public is_auto_cookie_sync: boolean = true;
    this.cookie_mode = "";
    this.shopExtEBusiness = [];
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("virtualdesktopform.please_select_a_platform"),
      trigger: "blur"
    }
  ])
], VirtualdesktopFormController.prototype, "platform_id", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("virtualdesktopform.please_enter_an_address"),
      trigger: "blur"
    }
  ])
], VirtualdesktopFormController.prototype, "shop_url", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "virtualdesktopform.please_enter_the_shop_name"
      ),
      trigger: "blur"
    }
  ])
], VirtualdesktopFormController.prototype, "name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "virtualdesktopform.browser_operation_language_must_be_selected"
      ),
      trigger: "blur"
    }
  ])
], VirtualdesktopFormController.prototype, "ui_language", 2);
export class VirtualDesktopController {
  constructor() {
    this._dialog = new UiDialogController();
    this._form = new VirtualdesktopFormController();
  }
  get form() {
    return this._form;
  }
  get dialog() {
    return this._dialog;
  }
}
let VirtualDesktopFormDialog = class extends Mixins(
  AccountSessionMixins
) {
  constructor() {
    super(...arguments);
    //店铺提交等待状态
    this.shopFormLoading = false;
    //是否是创建店铺
    this.is_create = true;
    //是否是从VD中创建店铺
    this.is_from_vd = false;
    //此店铺是否已经绑定了二步验证码
    this.totp_bind_flag = false;
    //VDID
    this.vd_id = "";
    //店铺ID
    this.shopId = "";
    // 店铺OldId
    this.shopOldId = "";
    //是否是自定义店铺
    this.isCustom = false;
    //是否展示店铺密码
    this.show_shop_password = true;
    //cookie是否开启同步模式
    this.cookie_auto_sync = false;
    //是否显示额外访问平台
    this.showExtBusiness = true;
    //店铺UI语言
    this.ui_language = "";
    //店铺分辨率参数
    this.screens = null;
    // vd_ua: string | null = null;
    //UI语言列表
    this.ui_languages = [];
    //选择平台和店铺类型
    this.selectedIds = {
      method: "create"
    };
    //店铺参数状态
    this.status = "ready";
    //当前平台
    this.current_platform = {
      can_bind_account: true,
      id: null,
      url: null,
      name: null
    };
    //创建或编辑店铺的标题
    this.shop_form_title = this.$t(
      "virtualdesktopform.create_a_store"
    );
    //分辨率列表
    this.resolutions = [];
    // 针对AI选项功能
    this.show_user_choose = false;
    // 授权员工列表
    this.choose_users = [];
    // 附件
    this.uploadManager = this.$store.state.uploadManager;
    //上传任务管理器
    // 等待附件列表加载状态
    this.loadingOfEnclosure = true;
    //附件列表loading
    // 任务状态显示列表
    this.taskType = taskMap;
    // 文件图标列表
    this.iconData = iconMap;
    //文件图标数据 = iconMap; //文件图标数据
    //上传附件列表
    this.uploadedEnclosureList = [];
    //当前临时osskey
    this.currentOssId = "";
    //上传中
    this.isUploading = true;
    //是否展示账号
    this.show_account = true;
    //是否展示密码
    this.show_password = true;
    //编辑锁
    this.edit_lock = true;
    //编辑平台
    this.edit_ebusiness = true;
    //是否展开了高级设置
    this.open_high_setting_flag = false;
    this.edit_platform = true;
    this.show_cookie_close = true;
    this.import_cookies = null;
    this.real_import_cookies = null;
    this.configData = new PaymentComputerConfigModel();
    this.profileModel = {
      country: null,
      // system:null,
      os: null,
      useragent: null,
      systemUnify: null,
      systemUnifyOs: null,
      systemUnifyUa: null,
      systemWindows: null,
      hasWindows: false,
      systemWindowsUa: null,
      systemMac: null,
      hasMac: false,
      systemMacUa: null,
      systemAndroid: null,
      hasAndroid: false,
      systemAndroidUa: null,
      systemLinux: null,
      hasLinux: false,
      systemLinuxUa: null,
      browser: null,
      payment_auto_resolution: null,
      payment_ratio: "AUTO",
      auto_timezone: null,
      is_auto_timezone: null,
      timezone: null,
      language: null,
      chrome_version: null,
      firefox_version: null
    };
    // 折叠面板重置状态
    this.activeCollapse = [];
    this.rsaEncrypt = new RSAEncryptUtil();
    this.browser_cores = [];
    this.chrome_versions = [
      {
        label: "106",
        value: "106"
      },
      {
        label: "114(Beta)",
        value: "114"
      }
    ];
    this.firefox_versions = [
      {
        label: "111(Beta)",
        value: "111"
      }
    ];
    this.fileUid = "";
  }
  onUploadManagerQueueTaskChange() {
    this.loadingOfEnclosure = false;
  }
  uploadErrorprompt() {
    if (this.uploadManager.errorPrompt === true) {
      this.$message({
        type: "error",
        message: this.$t("main.file_size_exceeds_limit")
      });
      this.uploadManager.errorPrompt = false;
    }
  }
  isOverSizePrompt() {
    if (this.uploadManager.isOverSize === true) {
      this.$message({
        type: "error",
        message: this.$t("main.space_exceeds_limit")
      });
      this.uploadManager.isOverSize = false;
    }
  }
  isMaxSizePrompt() {
    if (this.uploadManager.isMaxSize === true) {
      this.$message({
        type: "error",
        message: this.$t("main.file_number_exceeds_limit")
      });
      this.uploadManager.isMaxSize = false;
    }
  }
  refreshFileList() {
    if (this.uploadManager.refreshFileList === true) {
      this.isUploading = false;
      this.submit();
    }
  }
  // 文件id
  mounted() {
    window.addEventListener("beforeunload", (e) => {
      if (this.uploadManager.queueTask.length >= 1) {
        e.returnValue = "\u786E\u5B9A\u8981\u79BB\u5F00\u5417\uFF1F";
      }
    });
  }
  destroyed() {
    window.removeEventListener("beforeunload", (e) => {
    });
  }
  openEditTotpName(row) {
    this._edittotpnamedialog.open(row);
  }
  // 获取附件
  get listOfEnclosure() {
    let uploadedEnclosureList = this.uploadedEnclosureList.map((item) => {
      return {
        keyId: `${Math.random()}${Date.now()}${Math.random()}`,
        file: {
          name: item.name,
          path: item.path,
          size: item.size,
          lastModified: item.updateTime,
          fileId: item.fileUid,
          downloadUrl: item.downloadUrl
        },
        progress: 100,
        state: this.taskType.success,
        speed: 0,
        path: item.path,
        updateTime: item.updateTime,
        fileType: "upload"
      };
    });
    return this.$store.state.uploadManager.queueTask.concat(this.$store.state.uploadManager.historyTaskSuccess).concat(uploadedEnclosureList);
  }
  //打开添加或编辑额外访问店铺方法
  addExtraPlatform() {
    return __async(this, null, function* () {
      this._addVisitDialog.open(
        { shopId: "" },
        true,
        this._controller.form.shopExtEBusiness
      );
    });
  }
  addExtEbusiness(arr) {
    this._controller.form.shopExtEBusiness = arr;
  }
  getShopInfo(id) {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth.pro/v1/shops/${id}`, {
          params: {
            type: "edit"
          }
        });
        if (response.data.shopFiles && response.data.shopFiles.fileUid) {
          this.fileUid = response.data.shopFiles.fileUid;
        }
        this._controller.form.browser_core = response.data.browser.code;
        this.profileModel.chrome_version = response.data.browser.versionCode;
        if (response.data.extEbusinessPlatforms) {
          for (let item of response.data.extEbusinessPlatforms) {
            item.ebusiness_id = item.id;
            item.logo_url = item.logoUrl;
            if (item.mode === "CUSTOM") {
              item.custom = true;
              item.model = "custom";
            } else {
              item.custom = false;
              item.model = "platform";
            }
          }
        }
        this._controller.form.shopExtEBusiness = response.data.extEbusinessPlatforms ? response.data.extEbusinessPlatforms : [];
        yield this.getSystemConfiguration();
        this.profileModel.systemUnify = response.data.unifyEnv;
        if (this.profileModel.systemUnify) {
          this.profileModel.systemUnifyOs = response.data.osUserAgent.unify.osCode;
          this.profileModel.systemUnifyUa = response.data.osUserAgent.unify.userAgent;
          this.profileModel.systemWindows = response.data.osUserAgent.unify.osCode;
          this.profileModel.systemWindowsUa = response.data.osUserAgent.unify.userAgent;
        } else {
          if (response.data.osUserAgent.android) {
            this.profileModel.systemAndroid = response.data.osUserAgent.android.osCode;
            this.profileModel.systemAndroidUa = response.data.osUserAgent.android.userAgent;
          }
          if (response.data.osUserAgent.mac) {
            this.profileModel.systemMac = response.data.osUserAgent.mac.osCode;
            this.profileModel.systemMacUa = response.data.osUserAgent.mac.userAgent;
          }
          if (response.data.osUserAgent.windows) {
            this.profileModel.systemWindows = response.data.osUserAgent.windows.osCode;
            this.profileModel.systemWindowsUa = response.data.osUserAgent.windows.userAgent;
          }
          if (response.data.osUserAgent.linux) {
            this.profileModel.systemLinux = response.data.osUserAgent.linux.osCode;
            this.profileModel.systemLinuxUa = response.data.osUserAgent.linux.userAgent;
          }
        }
        if (response.data.mark) {
          let show_account_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_SHOW_ACCOUNT"
          ]);
          if (show_account_mark.length > 0) {
            this.show_account = false;
          } else {
            this.show_account = true;
          }
          let show_password_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_SHOW_PASS"
          ]);
          if (show_password_mark.length > 0) {
            this.show_password = false;
          } else {
            this.show_password = true;
          }
          let edit_lock_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_ALLOW_EDIT_LOCK"
          ]);
          if (edit_lock_mark.length > 0) {
            this.edit_lock = false;
          } else {
            this.edit_lock = true;
          }
          let edit_ebusiness_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_ALLOW_EDIT_EBUSINESS_TYPE"
          ]);
          if (edit_ebusiness_mark.length > 0) {
            this.edit_ebusiness = false;
          } else {
            this.edit_ebusiness = true;
          }
          let edit_platform_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_ALLOW_EDIT_EBUSINESS_PLATFORM"
          ]);
          if (edit_platform_mark.length > 0) {
            this.edit_platform = false;
          } else {
            this.edit_platform = true;
          }
          let show_Ext_Business_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_ALLOW_ADD_EXT_BUSINESS"
          ]);
          if (show_Ext_Business_mark.length > 0) {
            this.showExtBusiness = false;
          } else {
            this.showExtBusiness = true;
          }
          let show_cookie_close_mark = _.intersection(response.data.mark, [
            "SHOP_NOT_ALLOW_CLOSE_COOKIE"
          ]);
          if (show_cookie_close_mark.length > 0) {
            this.show_cookie_close = false;
          } else {
            this.show_cookie_close = true;
          }
          if (response.data.mark.tags) {
            let show_account_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_SHOW_ACCOUNT"
            ]);
            if (show_account_mark2.length > 0) {
              this.show_account = false;
            } else {
              this.show_account = true;
            }
            let show_password_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_SHOW_PASS"
            ]);
            if (show_password_mark2.length > 0) {
              this.show_password = false;
            } else {
              this.show_password = true;
            }
            let edit_lock_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_ALLOW_EDIT_LOCK"
            ]);
            if (edit_lock_mark2.length > 0) {
              this.edit_lock = false;
            } else {
              this.edit_lock = true;
            }
            let edit_ebusiness_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_ALLOW_EDIT_EBUSINESS_TYPE"
            ]);
            if (edit_ebusiness_mark2.length > 0) {
              this.edit_ebusiness = false;
            } else {
              this.edit_ebusiness = true;
            }
            let edit_platform_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_ALLOW_EDIT_EBUSINESS_PLATFORM"
            ]);
            if (edit_platform_mark2.length > 0) {
              this.edit_platform = false;
            } else {
              this.edit_platform = true;
            }
            let show_Ext_Business_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_ALLOW_ADD_EXT_BUSINESS"
            ]);
            if (show_Ext_Business_mark2.length > 0) {
              this.showExtBusiness = false;
            } else {
              this.showExtBusiness = true;
            }
            let show_cookie_close_mark2 = _.intersection(response.data.mark.tags, [
              "SHOP_NOT_ALLOW_CLOSE_COOKIE"
            ]);
            if (show_cookie_close_mark2.length > 0) {
              this.show_cookie_close = false;
            } else {
              this.show_cookie_close = true;
            }
          }
        }
        if (response.data.marks) {
          let show_account_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_SHOW_ACCOUNT"
          ]);
          if (show_account_mark.length > 0) {
            this.show_account = false;
          } else {
            this.show_account = true;
          }
          let show_password_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_SHOW_PASS"
          ]);
          if (show_password_mark.length > 0) {
            this.show_password = false;
          } else {
            this.show_password = true;
          }
          let edit_lock_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_ALLOW_EDIT_LOCK"
          ]);
          if (edit_lock_mark.length > 0) {
            this.edit_lock = false;
          } else {
            this.edit_lock = true;
          }
          let edit_ebusiness_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_ALLOW_EDIT_EBUSINESS_TYPE"
          ]);
          if (edit_ebusiness_mark.length > 0) {
            this.edit_ebusiness = false;
          } else {
            this.edit_ebusiness = true;
          }
          let edit_platform_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_ALLOW_EDIT_EBUSINESS_PLATFORM"
          ]);
          if (edit_platform_mark.length > 0) {
            this.edit_platform = false;
          } else {
            this.edit_platform = true;
          }
          let show_Ext_Business_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_ALLOW_ADD_EXT_BUSINESS"
          ]);
          if (show_Ext_Business_mark.length > 0) {
            this.showExtBusiness = false;
          } else {
            this.showExtBusiness = true;
          }
          let show_cookie_close_mark = _.intersection(response.data.marks, [
            "SHOP_NOT_ALLOW_CLOSE_COOKIE"
          ]);
          if (show_cookie_close_mark.length > 0) {
            this.show_cookie_close = false;
          } else {
            this.show_cookie_close = true;
          }
        }
        yield this.getUploadedFiles(this.fileUid);
        return response.data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
        return null;
      }
    });
  }
  clearFileList() {
    this.uploadManager.clearQueue();
  }
  closeModal(done) {
    if (this.uploadManager.queueTask.length > 0) {
      this.$confirm(
        this.$t("main.attachment_not_saved"),
        this.$t("main.hint"),
        {
          confirmButtonText: this.$t("main.leave"),
          cancelButtonText: this.$t("main.cancel"),
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        done();
      }));
    } else {
      done();
    }
  }
  //打开配置二步验证器弹窗
  openEditTotp() {
    return __async(this, null, function* () {
      try {
        if (!this._controller.form.totp_data || (this._controller.form.totp_data.totp_secret === "" || this._controller.form.totp_data.totp_secret === null) && (this._controller.form.totp_data.totp_guid === null || this._controller.form.totp_data.totp_guid === "")) {
          yield this._configTotpDialog.open(this.is_create);
        } else {
          yield this._configTotpDialog.open(
            this.is_create,
            this._controller.form.totp_data
          );
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //打开添加TOTP弹窗
  openAddTOTP() {
    try {
      this._addtotpdialog.open();
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  //添加TOTP成功
  uploadSuccess(data) {
    return __async(this, null, function* () {
      this._controller.form.totp_data = {
        totp_secret: data.secret ? data.secret : null,
        totp_name: data.name,
        totp_account: data.username,
        totp_guid: data.id ? data.id : null,
        totp_num: data.bindShopNum ? data.bindShopNum : 1
      };
      yield this._configTotpDialog.bindDatas(this._controller.form.totp_data);
    });
  }
  //编辑TOTP名称
  editTOTPName(data) {
    return __async(this, null, function* () {
      try {
        this._controller.form.totp_data.totp_name = data.name;
        if (this._controller.form.totp_data.totp_guid !== null && this._controller.form.totp_data.totp_guid !== "") {
          yield API.put(
            `api://base.auth.pro/v1/shop-two-step-verifications/${this._controller.form.totp_data.totp_guid}`,
            {
              name: data.name
            }
          );
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //删除TOTP
  deleteTotpConfig() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("config_totp_dialog.unbind_tip_content"),
          this.$t("config_totp_dialog.unbind_tip_title"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel"),
            customClass: "new-confirm-box",
            iconClass: "el-icon-warning"
          }
        );
        this._controller.form.totp_data = null;
        yield this._configTotpDialog.bindDatas();
        if (!this.is_create && this.totp_bind_flag) {
          yield API.delete(
            `api://base.auth.pro/v1/shops/${this.shopId}/two-step-verifications`
          );
          this.totp_bind_flag = false;
        }
        this.$message.success(
          this.$t("virtualdesktopform.delete_shop_totp_success")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //解绑TOTP
  unbindTOTP() {
    return __async(this, null, function* () {
      try {
        this._controller.form.totp_data = null;
        yield this._configTotpDialog.bindDatas();
        if (!this.is_create && this.totp_bind_flag) {
          yield API.delete(
            `api://base.auth.pro/v1/shops/${this.shopId}/two-step-verifications`
          );
          this.totp_bind_flag = false;
        }
        this.$message.success(
          this.$t("virtualdesktopform.unbind_totp_success")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //获取TOTP密钥
  getTOTPSecret() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v9/shop/${this.shopOldId}/two-step-verifications`
        );
        this._controller.form.totp_data = {
          totp_name: response.data.name,
          totp_guid: response.data.id,
          totp_secret: response.data.secret,
          totp_account: response.data.account,
          totp_num: response.data.bindShopNum
        };
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //绑定TOTP
  bindTOTP() {
    return __async(this, null, function* () {
      try {
        if (this._controller.form.totp_data !== null && this._controller.form.totp_data.totp_guid !== null) {
          let data = {
            id: this._controller.form.totp_data.totp_guid,
            secret: this._controller.form.totp_data.totp_secret,
            name: this._controller.form.totp_data.totp_name,
            account: this._controller.form.totp_data.totp_account
          };
          this._bindtotpbylistdialog.open(data);
        } else {
          this._bindtotpbylistdialog.open();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //删除TOTP
  deleteTOTP() {
    return __async(this, null, function* () {
      try {
        if (this._controller.form.totp_data && this._controller.form.totp_data.totp_guid !== null) {
          yield API.delete(
            `api://base.auth.pro/v1/shop-two-step-verifications/${this._controller.form.totp_data.totp_guid}`
          );
        }
        this._controller.form.totp_data = null;
        yield this._configTotpDialog.bindDatas();
        this.$message.success(
          this.$t("virtualdesktopform.delete_totp_success")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  deleteRequestOfEnclosure() {
  }
  saveUsers(data) {
    this.choose_users = data;
    let ids = _.map(data, "id");
    this._controller.form.user_ids = ids;
  }
  showChooseUsers() {
    return __async(this, null, function* () {
      if (this.shopOldId !== null && this.shopOldId !== "") {
        this._shopChooseUsers.open(this.choose_users, this.shopOldId);
      } else if (this.vd_id !== null && this.vd_id !== "") {
        this._shopChooseUsers.open(this.choose_users, null, this.vd_id);
      } else {
        this._shopChooseUsers.open(this.choose_users);
      }
    });
  }
  // 打开上传的windows框
  openUpload() {
    this._fileUpload.shopId = this.shopOldId;
    this._fileUpload.openUpload();
  }
  // 已上传的附件
  getUploadedFiles(fileId) {
    return __async(this, null, function* () {
      if (!fileId) {
        return;
      }
      try {
        let response = yield API.get(`api://base.auth.pro/v1/files/${fileId}`);
        this.uploadedEnclosureList = response.data;
        this.loadingOfEnclosure = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 下载全部附件
  downloadAllEnclosure() {
    if (this.uploadedEnclosureList.length === 0) {
      return;
    }
    for (let index = 0; index < this.uploadedEnclosureList.length; index++) {
      this.downloadEnclosure(this.uploadedEnclosureList[index].downloadUrl);
    }
  }
  // 下载
  downloadEnclosure(url) {
    let a = document.createElement("a");
    a.href = url;
    a.download = "";
    a.click();
  }
  // 删除全部附件
  deleteAllEnclosure() {
    if (this.listOfEnclosure.length === 0) {
      return;
    }
    this.$confirm(
      this.$t("main.this_action_will_delete_all_attachments"),
      this.$t("main.hint"),
      {
        confirmButtonText: this.$t("main.delete"),
        cancelButtonText: this.$t("main.cancel"),
        type: "warning"
      }
    ).then(() => __async(this, null, function* () {
      this.loadingOfEnclosure = true;
      this.clearFileList();
      yield this.deleteFile(this.listOfEnclosure);
    }));
  }
  //大小转换
  transform(size) {
    return Transform(size);
  }
  // 下载当前附件
  downloadCurrentEnclosure(item) {
    return __async(this, null, function* () {
      if (item.fileType === "local") {
        this.download(URL.createObjectURL(item.file), item.file.name);
      } else {
        try {
          let res = yield API.get(`api://base.auth.pro/v1/files-download`, {
            params: {
              filePath: item.path
            }
          });
          window.open(res.data.data);
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
    });
  }
  download(href, title) {
    const a = document.createElement("a");
    a.setAttribute("href", href);
    a.setAttribute("download", title);
    a.click();
  }
  // 删除当前附件
  deleteCurrentEnclosure(item) {
    this.$confirm(
      this.$t("main.this_action_will_delete_attachments"),
      this.$t("main.hint"),
      {
        confirmButtonText: this.$t("main.delete"),
        cancelButtonText: this.$t("main.cancel"),
        type: "warning"
      }
    ).then(() => __async(this, null, function* () {
      this.loadingOfEnclosure = true;
      if (item.fileType === "local") {
        this.uploadManager.removeCurrentTask(item);
        this.$message.success(this.$t("main.delete_successful"));
      } else {
        this.deleteFile([item]);
      }
    }));
  }
  // 发送删除请求
  deleteFile(item) {
    return __async(this, null, function* () {
      try {
        let response = yield API.delete(
          `api://base.auth/api/v7/goods-files/remote`,
          {
            data: {
              file_uid: item[0].file.fileId,
              files: item.map((item2) => item2.fileType !== "local" && item2.path)
            }
          }
        );
        this.$message.success(this.$t("main.delete_successful"));
        this.getUploadedFiles(item[0].file.fileId);
        this.loadingOfEnclosure = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
        this.loadingOfEnclosure = false;
      }
    });
  }
  // 获取权限
  getCurrentPower() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth.pro/v1/files-space`
        );
        this.uploadManager.maxUploadSize = response.data.singleFileMaxSize;
        this.uploadManager.maxUploadFileNumber = response.data.usableCount;
        this.uploadManager.remainingSpace = response.data.totalFileUsableSize;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 打开配置子账号自动二步验证的黑名单
  openBlackList() {
    return __async(this, null, function* () {
      try {
        if (this.is_create === true && this._controller.form.blacklist === null) {
          yield this._totpblacklistdialog.open();
        } else {
          yield this._totpblacklistdialog.open(this._controller.form);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 配置黑名单数据完成
  chooseBlackListComplete(data) {
    return __async(this, null, function* () {
      try {
        this._controller.form.blacklist = data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  open(shopId, vd_id, is_admin) {
    return __async(this, null, function* () {
      yield this.getCurrentPower();
      this.isUploading = true;
      this.uploadedEnclosureList = [];
      this.fileUid = "";
      this.uploadManager.clearQueue();
      this.is_from_vd = false;
      this.vd_id = "";
      this.shopId = "";
      this.is_create = true;
      this.shop_form_title = this.$t("virtualdesktopform.edit_shop");
      let formData = null;
      this._controller.dialog.visible = true;
      this.shopFormLoading = true;
      this.selectedIds = {
        method: "create"
      };
      if (shopId) {
        yield this.getBrowserConfiguration(false);
      } else {
        yield this.getBrowserConfiguration(true);
      }
      yield this.getSystemConfiguration();
      if (this.$session.type === "account" || this.$session.permissions.any("SHOW_ALL_MENUS", "SHOP_REASSIGN") || is_admin) {
        this.show_user_choose = true;
      }
      if (shopId) {
        this.shopId = shopId;
        this.is_create = false;
        formData = yield this.getShopInfo(shopId);
        this.shopOldId = formData == null ? void 0 : formData.oldId;
      }
      if (!formData) {
        formData = new BindShopProFormModel();
        this.is_create = true;
        this.shop_form_title = this.$t(
          "virtualdesktopform.create_a_store"
        );
        this.activeCollapse = [];
        this.current_platform = {
          can_bind_account: true,
          id: null,
          name: null,
          url: null
        };
        if (vd_id !== null && vd_id !== void 0) {
          this.is_from_vd = true;
          this.vd_id = vd_id;
          let _result = yield API.get(
            `api://base.auth.pro/v1/virtual-desktops/${vd_id}/environment`
          );
          let item = _result.data;
          let ui_languages = yield API.get(
            `api://base.auth/api/v7/browser_ui_languages`
          );
          this.ui_languages = ui_languages.data.datas;
          this.cookie_auto_sync = item.isAutoCookieSync;
          this.ui_language = item.uiLanguage;
          if (item.resolutionMode === "custom") {
            this.profileModel.payment_ratio = item.screen;
          } else {
            this.profileModel.payment_ratio = "AUTO";
          }
          this.profileModel.systemUnify = item.unifyOs;
          this.profileModel.systemUnifyOs = item.os.windows;
          this.profileModel.systemUnifyUa = item.useragent.unifyUa;
          if (this.profileModel.systemUnify) {
            if (this.profileModel.hasWindows === true) {
              this.profileModel.systemWindows = item.os.windows;
              this.profileModel.systemWindowsUa = item.useragent.unifyUa;
            }
            if (this.profileModel.hasMac === true) {
              this.profileModel.systemMac = this.configData.os.mac[0];
              this.profileModel.systemMacUa = this.configData.useragent[this.profileModel.systemMac][0];
            }
            if (this.profileModel.hasAndroid === true) {
              this.profileModel.systemAndroid = this.configData.os.android[0];
              this.profileModel.systemAndroidUa = this.configData.useragent[this.profileModel.systemAndroid][0];
            }
            if (this.profileModel.hasLinux === true) {
              this.profileModel.systemLinux = this.configData.os.linux[0];
              this.profileModel.systemLinuxUa = this.configData.useragent[this.profileModel.systemLinux][0];
            }
          } else {
            this.profileModel.systemWindows = item.os.windows;
            this.profileModel.systemWindowsUa = item.useragent.winUa;
            this.profileModel.systemMac = item.os.mac;
            this.profileModel.systemMacUa = item.useragent.macUa;
            this.profileModel.systemAndroid = item.os.android;
            this.profileModel.systemAndroidUa = item.useragent.androidUa;
            this.profileModel.systemLinux = item.os.linux;
            this.profileModel.systemLinuxUa = item.useragent.linuxUa;
          }
        }
      }
      if (!this.is_from_vd) {
        let ui_languages = yield API.get(
          `api://base.auth/api/v7/browser_ui_languages`
        );
        this.ui_languages = ui_languages.data.datas;
      }
      let response = yield API.get(`api://base.auth/api/v7/resolution_list`);
      let resolutions_arr = [];
      for (let item of response.data.datas) {
        resolutions_arr.push(item);
      }
      this.resolutions = resolutions_arr;
      this.$nextTick(() => __async(this, null, function* () {
        var _a, _b, _c, _d;
        if (this.is_create) {
          this._controller.form.platform_style = "all";
          this._controller.form.resolution_mode = "auto";
          this._controller.form.name = "";
          this._controller.form.shop_url = "";
          this._controller.form.lock_account = false;
          this._controller.form.account = "";
          this._controller.form.password = "";
          this._controller.form.choose_user = "";
          this._controller.form.totp_data = null;
          this._controller.form.blacklist = null;
          this.totp_bind_flag = false;
          this.choose_users = [];
          this._controller.form.user_ids = [];
          this._controller.form.platform_id = "";
          this._controller.form.cookie_mode = "SHOP_COOKIE_AUTOSYNC";
          this._controller.form.third_party_cookie_auth = false;
          this._controller.form.screen = "";
          this.profileModel.payment_ratio = "AUTO";
          this._controller.form.shop_lock = false;
          this._controller.form.shop_lock_num = 1;
          this._controller.form.ui_language = "zh-CN";
          this._controller.form.browser_core = "chrome";
          this._controller.form.shopExtEBusiness = [];
          this.import_cookies = null;
          this.real_import_cookies = null;
          if (this.is_from_vd) {
            this._controller.form.platform_style = "all";
            this._controller.form.resolution_mode = "use_vd";
            this._controller.form.name = "";
            this._controller.form.ui_language = this.ui_language;
            if (this._envId !== "" && this._envId !== null && this._envId !== void 0) {
              let resp = yield API.get(
                `api://base.auth/api/v5/environment/${this._envId}/data`
              );
              this._controller.form.resolution_mode = "custom";
              this._controller.form.screen = resp.data.screen;
              this._controller.form.ui_language = resp.data.language;
              this.cookie_auto_sync = true;
            }
            if (this.cookie_auto_sync) {
              this._controller.form.cookie_mode = "SHOP_COOKIE_AUTOSYNC";
            } else {
              this._controller.form.cookie_mode = "SHOP_COOKIE_NOSYNC";
            }
          }
        } else {
          if (vd_id !== null && vd_id !== void 0) {
            this.vd_id = vd_id;
            this.is_from_vd = true;
          }
          if (formData.url) {
            this._controller.form.platform_style = "Custom";
          } else {
            this._controller.form.platform_style = "all";
          }
          this._controller.form.platform_id = formData.ebusinessPlatformId;
          if (formData.authUsers) {
            let arr = [];
            for (let data of formData.authUsers) {
              let item = {
                id: data.id,
                label: data.name
              };
              arr.push(item);
            }
            this.choose_users = arr;
            this._controller.form.user_ids = _.map(formData.authUsers, "id");
          } else {
            this.choose_users = [];
            this._controller.form.user_ids = [];
          }
          this._controller.form.name = formData.name;
          this._controller.form.shop_url = (_a = formData.url) != null ? _a : "";
          this._controller.form.resolution_mode = formData.resolution.mode;
          this._controller.form.screen = (_b = formData.resolution.screen) != null ? _b : "";
          this._controller.form.shop_lock = formData.shopLock.lock;
          this._controller.form.shop_lock_num = (_c = formData.shopLock.lockNum) != null ? _c : 1;
          this._controller.form.third_party_cookie_auth = formData.thirdPartyAuth;
          this._controller.form.sub_platforms = (_d = formData.extEbusinessPlatforms) != null ? _d : [];
          this._controller.form.lock_account = formData.lockAccount || false;
          this._controller.form.account = formData.account || "";
          this._controller.form.password = formData.password || "";
          this._controller.form.ui_language = formData.uiLanguage;
          this._controller.form.cookie_mode = formData.cookieSync || "SHOP_COOKIE_AUTOSYNC";
          this._controller.form.totp_data = null;
          if (formData.twoStepValidSecret && formData.twoStepValidSecret.id !== "" && formData.twoStepValidSecret.id !== null) {
            this.totp_bind_flag = true;
            this._controller.form.blacklist = formData.twoStepValidBlackList;
            yield this.getTOTPSecret();
          } else {
            this.totp_bind_flag = false;
          }
        }
        if (this._controller.form.platform_style !== "Custom" && formData.ebusinessId !== "" && formData.ebusinessId !== null && formData.ebusinessId !== void 0) {
          try {
            let response2 = yield API.get(
              `api://base.auth/api/v7/ebusinesses/${formData.ebusinessId}/platforms_list`
            );
            let platForm = _.find(response2.data.datas, (item) => {
              return item.guid === formData.ebusinessPlatformId;
            });
            this.current_platform.can_bind_account = platForm.can_bind_account;
            this.current_platform.id = platForm.guid;
            this.current_platform.url = platForm.url_display;
            this.current_platform.name = platForm.name;
            this.selectedIds = {
              plate: formData == null ? void 0 : formData.ebusinessId,
              web: formData == null ? void 0 : formData.ebusinessPlatformId,
              method: "edit"
            };
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
        }
        if (this._controller.form.platform_style === "Custom") {
          this.isCustom = true;
        } else {
          this.isCustom = false;
        }
        yield this.styleChange();
      }));
      this.shopFormLoading = false;
    });
  }
  checkJson(str) {
    try {
      if (typeof JSON.parse(str) == "object") {
        return true;
      }
    } catch (error) {
    }
    return false;
  }
  encryptData(datas) {
    const key = CryptoJS.enc.Utf8.parse("7fe7df58b0faa649");
    const srcs = CryptoJS.enc.Utf8.parse(datas);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: key,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString().toUpperCase();
  }
  //Cookie格式转换
  formatCookies(cookies) {
    let jsonData = JSON.parse(cookies);
    for (const cookieItem of jsonData) {
      for (let key in cookieItem) {
        let key_new = key.replace(key[0], key[0].toLowerCase());
        if (key_new === key) {
          continue;
        } else {
          cookieItem[key_new] = cookieItem[key];
          delete cookieItem[key];
        }
      }
    }
    return this.encryptData(JSON.stringify(jsonData));
  }
  getBrowserConfiguration(flag) {
    return __async(this, null, function* () {
      try {
        let browser_response = yield API.get(
          `api://base.auth/api/v1/browser-versions`
        );
        this.browser_cores = browser_response.data.browserList;
        if (flag && flag === true) {
          let data = [];
          for (const chromeVersion of browser_response.data.browserVersion.chrome) {
            if (chromeVersion.version !== "106") {
              data.push(chromeVersion);
            }
          }
          this.chrome_versions = data;
        } else {
          this.chrome_versions = browser_response.data.browserVersion.chrome;
        }
        this.firefox_versions = browser_response.data.browserVersion.firefox;
        this._controller.form.browser_core = this.browser_cores[0].code;
        if (flag && flag === true) {
          let browser_version = _.find(this.chrome_versions, { isDefault: true });
          if (browser_version && browser_version !== void 0) {
            this.profileModel.chrome_version = browser_version.code;
          } else {
            this.profileModel.chrome_version = this.chrome_versions[0].code;
          }
        } else {
          this.profileModel.chrome_version = this.chrome_versions[0].code;
        }
        if (this.firefox_versions) {
          this.profileModel.firefox_version = this.firefox_versions[0].code;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeHighSettings(data) {
    return __async(this, null, function* () {
      if (data.length === 1) {
        this.open_high_setting_flag = true;
      } else {
        this.open_high_setting_flag = false;
      }
    });
  }
  getSystemConfiguration() {
    return __async(this, null, function* () {
      try {
        let data = {
          browser: this._controller.form.browser_core,
          browserVersion: this._controller.form.browser_core === "chrome" ? this.profileModel.chrome_version : this.profileModel.firefox_version
        };
        let result = yield API.get(`api://base.auth/api/v1/useragents`, {
          params: data
        });
        this.configData = result.data;
        this.profileModel.os = this.configData.os;
        this.profileModel.useragent = this.configData.useragent;
        if (this.is_create) {
          this.profileModel.systemUnify = false;
          this.profileModel.systemUnifyOs = "";
          this.profileModel.systemUnifyUa = "";
        }
        if (this.configData.os.hasOwnProperty("windows")) {
          this.profileModel.hasWindows = true;
          this.profileModel.systemWindows = this.configData.os.windows[0];
          this.profileModel.systemWindowsUa = this.configData.useragent[this.profileModel.systemWindows][0];
        } else {
          this.profileModel.hasWindows = false;
        }
        if (this.configData.os.hasOwnProperty("mac")) {
          this.profileModel.hasMac = true;
          this.profileModel.systemMac = this.configData.os.mac[0];
          this.profileModel.systemMacUa = this.configData.useragent[this.profileModel.systemMac][0];
        } else {
          this.profileModel.hasMac = false;
        }
        if (this.configData.os.hasOwnProperty("android")) {
          this.profileModel.hasAndroid = true;
          this.profileModel.systemAndroid = this.configData.os.android[0];
          this.profileModel.systemAndroidUa = this.configData.useragent[this.profileModel.systemAndroid][0];
        } else {
          this.profileModel.hasAndroid = false;
        }
        if (this.configData.os.hasOwnProperty("linux")) {
          this.profileModel.hasLinux = true;
          this.profileModel.systemLinux = this.configData.os.linux[0];
          this.profileModel.systemLinuxUa = this.configData.useragent[this.profileModel.systemLinux][0];
        } else {
          this.profileModel.hasLinux = false;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeUnify() {
    if (this.profileModel.systemUnify) {
      this.profileModel.systemUnifyOs = this.profileModel.systemWindows;
      this.profileModel.systemUnifyUa = this.profileModel.systemWindowsUa;
    } else {
      this.profileModel.systemUnifyOs = null;
      this.profileModel.systemUnifyUa = null;
    }
  }
  getNewUa() {
    const windowsUaList = this.profileModel.useragent[this.profileModel.systemWindows];
    if (windowsUaList.length > 1) {
      let newSystemWindowsUa = "";
      do {
        newSystemWindowsUa = windowsUaList[Math.floor(Math.random() * windowsUaList.length)];
      } while (newSystemWindowsUa === this.profileModel.systemWindowsUa);
      this.profileModel.systemWindowsUa = newSystemWindowsUa;
    }
    const macUaList = this.profileModel.useragent[this.profileModel.systemMac];
    if (macUaList.length > 1) {
      let newSystemMacUa = "";
      do {
        newSystemMacUa = macUaList[Math.floor(Math.random() * macUaList.length)];
      } while (newSystemMacUa === this.profileModel.systemMacUa);
      this.profileModel.systemMacUa = newSystemMacUa;
    }
    const androidUaList = this.profileModel.useragent[this.profileModel.systemAndroid];
    if (androidUaList.length > 1) {
      let newSystemAndroidUa = "";
      do {
        newSystemAndroidUa = androidUaList[Math.floor(Math.random() * androidUaList.length)];
      } while (newSystemAndroidUa === this.profileModel.systemAndroidUa);
      this.profileModel.systemAndroidUa = newSystemAndroidUa;
    }
  }
  changeSystem(type) {
    if (type === "windows") {
      this.profileModel.systemWindowsUa = this.profileModel.useragent[this.profileModel.systemWindows][0];
    }
    if (type === "mac") {
      this.profileModel.systemMacUa = this.profileModel.useragent[this.profileModel.systemMac][0];
    }
    if (type === "android") {
      this.profileModel.systemAndroidUa = this.profileModel.useragent[this.profileModel.systemAndroid][0];
    }
  }
  select(item) {
    this._controller.form.platform_id = item.webinfo.guid;
    this.current_platform.name = item.webinfo.name;
    this.current_platform.url = item.webinfo.url_display;
    if (item.plateinfo.code === "CUSTOM") {
      this.isCustom = true;
      this._controller.form.platform_style = "Custom";
    }
    if (item.plateinfo.code !== "CUSTOM") {
      this.isCustom = false;
      this.current_platform.can_bind_account = item.webinfo.can_bind_account;
    }
  }
  changeplate(data) {
    if (data === "Custom") {
      this._controller.form.platform_style = "Custom";
      return;
    }
    if (data === "IndependentSite") {
      this._controller.form.platform_style = "IndependentSite";
      return;
    }
    this._controller.form.platform_style = "all";
  }
  getLabel(item) {
    if (item) {
      if (item.url) {
        return `${item.name}(${item.url})`;
      }
      return item.name;
    }
    return this.$t("virtualdesktopform.select_a_platform_site");
  }
  getUsers(item) {
    if (item.length > 0) {
      let arr = [];
      for (let data of item) {
        arr.push(data.label);
      }
      return arr.join(",");
    }
    return this.$t("virtualdesktopform.choose_users");
  }
  chooseWebsite() {
    return __async(this, null, function* () {
      yield this._shopPlatform.open();
    });
  }
  styleChange() {
    return __async(this, null, function* () {
      if (this._controller.form.platform_style === "Custom") {
        this.isCustom = true;
      }
      if (this._controller.form.platform_style !== "Custom") {
        this.isCustom = false;
      }
    });
  }
  // 获取临时授权的id
  getCurrentOssId() {
    if (this.uploadManager.historyTaskSuccess.length) {
      return this.uploadManager.tmpAuth.id;
    } else {
      return "";
    }
  }
  // 获取文件列表
  getFileList() {
    var _a, _b;
    return (_b = (_a = this.uploadManager.historyTaskSuccess) == null ? void 0 : _a.map((item) => {
      return {
        filePath: item.path,
        fileRealName: item.file.name
      };
    })) != null ? _b : [];
  }
  // 保存之前提交附件
  beforeSaveSubmitFiles() {
    if (this.uploadManager.queueTask.length > 0) {
      this.loading = this.$loading({
        lock: true,
        fullscreen: true,
        text: this.$t("headertoolbar.uploading_enclosure"),
        customClass: "hard-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
      this.isUploading = true;
      this.uploadManager.start();
      return;
    }
  }
  // 保存信息
  submit() {
    return __async(this, null, function* () {
      if (this.is_create && this.import_cookies !== null && this.import_cookies !== "" && this._controller.form.cookie_mode === "SHOP_COOKIE_NOSYNC") {
        this.$message.error(
          this.$t("importCookiesDialog.open_cookie_mode_tip")
        );
        this.status = "ready";
        return;
      }
      if (this.is_create && this.import_cookies !== null && this.import_cookies !== "" && this._controller.form.cookie_mode !== "SHOP_COOKIE_NOSYNC") {
        let flag = this.checkJson(this.import_cookies);
        if (!flag) {
          this.$message.error(
            this.$t("importCookiesDialog.import_cookie_wrong_type")
          );
          this.status = "ready";
          return;
        } else {
          try {
            this.real_import_cookies = this.formatCookies(this.import_cookies);
          } catch (error) {
            this.$message.error(
              this.$t("importCookiesDialog.import_cookie_wrong_type_2")
            );
            this.status = "ready";
            return;
          }
        }
      }
      try {
        this.status = "submit";
        let url = ``;
        if (this.profileModel.systemUnify) {
          this.profileModel.systemUnifyOs = this.profileModel.systemWindows;
          this.profileModel.systemUnifyUa = this.profileModel.systemWindowsUa;
        } else {
          this.profileModel.systemUnifyOs = null;
          this.profileModel.systemUnifyUa = null;
        }
        if (this.profileModel.payment_ratio === "AUTO") {
          this._controller.form.resolution_mode = "AUTO";
          this._controller.form.screen = "";
        } else {
          this._controller.form.resolution_mode = "CUSTOM";
          this._controller.form.screen = this.profileModel.payment_ratio;
        }
        if (this.isUploading && this.uploadManager.queueTask.length > 0) {
          this.beforeSaveSubmitFiles();
          return;
        }
        this.loading && this.loading.close();
        let submitData = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
          // 创建店铺
          model: "shop.custom",
          // 店铺名称
          name: this._controller.form.name,
          // Cookie同步模式
          cookieSync: this._controller.form.cookie_mode,
          // 店铺账号
          account: this._controller.form.account,
          // 店铺密码
          password: this._controller.form.password,
          // 是否锁定
          lockAccount: this._controller.form.lock_account
        }, (() => {
          if (this.getCurrentOssId() !== null && this.getCurrentOssId() !== "") {
            return {
              shopFiles: {
                fileUid: this.getCurrentOssId(),
                files: this.getFileList()
              }
            };
          }
        })()), (() => {
          if (this.profileModel.systemUnify === true) {
            return {
              osUserAgent: {
                model: "shop.unify.os.ua",
                unify: {
                  osCode: this.profileModel.systemUnifyOs,
                  userAgent: this.profileModel.systemUnifyUa
                }
              }
            };
          }
          if (this.profileModel.systemUnify === false) {
            return {
              osUserAgent: {
                model: "shop.os.ua",
                windows: {
                  osCode: this.profileModel.systemWindows,
                  userAgent: this.profileModel.systemWindowsUa
                },
                mac: {
                  osCode: this.profileModel.systemMac,
                  userAgent: this.profileModel.systemMacUa
                },
                android: {
                  osCode: this.profileModel.systemAndroid,
                  userAgent: this.profileModel.systemAndroidUa
                },
                linux: {
                  osCode: this.profileModel.systemLinux,
                  userAgent: this.profileModel.systemLinuxUa
                }
              }
            };
          }
        })()), (() => {
          if (this._controller.form.resolution_mode === "AUTO") {
            return {
              resolution: {
                mode: this._controller.form.resolution_mode,
                screen: null
              }
            };
          }
          if (this._controller.form.resolution_mode === "CUSTOM") {
            return {
              resolution: {
                mode: this._controller.form.resolution_mode,
                screen: this._controller.form.screen
              }
            };
          }
        })()), {
          // UI语言
          uiLanguage: this._controller.form.ui_language,
          // 店铺锁参数
          shopLock: {
            lock: this._controller.form.shop_lock,
            lockNum: Number(this._controller.form.shop_lock_num)
          },
          // 是否允许第三方cookie
          thirdPartyAuth: this._controller.form.third_party_cookie_auth
        }), (() => {
          if (this._controller.form.totp_data !== null) {
            if (this._controller.form.totp_data.totp_guid !== null && this._controller.form.totp_data.totp_guid !== "") {
              return {
                twoStepValidSecret: {
                  model: "two.step.valid.secret.select",
                  id: this._controller.form.totp_data.totp_guid
                }
              };
            }
            if (this._controller.form.totp_data.totp_guid === null || this._controller.form.totp_data.totp_guid === "") {
              return {
                twoStepValidSecret: {
                  model: "two.step.valid.secret.add",
                  name: this._controller.form.totp_data.totp_name,
                  account: this._controller.form.totp_data.totp_account,
                  secret: this._controller.form.totp_data.totp_secret
                }
              };
            }
          }
        })()), (() => {
          if (this._controller.form.blacklist !== null) {
            let ids = _.map(this._controller.form.blacklist.datas, "id");
            let data = {
              "type": this._controller.form.blacklist.type,
              "ids": ids
            };
            return {
              twoStepValidBlackList: data
            };
          }
        })()), (() => {
          if (this._controller.form.browser_core === "chrome") {
            return {
              browser: {
                code: this._controller.form.browser_core,
                versionCode: this.profileModel.chrome_version
              }
            };
          } else {
            return {
              browser: {
                code: this._controller.form.browser_core,
                versionCode: this.profileModel.firefox_version
              }
            };
          }
        })()), (() => {
          if (this.is_create && this.import_cookies !== null && this.import_cookies !== "" && this._controller.form.cookie_mode !== "SHOP_COOKIE_NOSYNC") {
            return {
              cookies: this.real_import_cookies
            };
          }
        })()), (() => {
          if (this._controller.form.user_ids && this._controller.form.user_ids.length > 0) {
            return {
              authUsers: this._controller.form.user_ids
            };
          }
        })()), (() => {
          if (this.isCustom) {
            return {
              ebusinessPlatform: {
                model: "shop.custom.platform",
                url: this._controller.form.shop_url
              }
            };
          } else {
            return {
              ebusinessPlatform: {
                model: "shop.platform",
                id: this._controller.form.platform_id
              }
            };
          }
        })()), (() => {
          if (this._controller.form.shopExtEBusiness && this._controller.form.shopExtEBusiness.length > 0) {
            let arr = [];
            for (let item of this._controller.form.shopExtEBusiness) {
              let data = {};
              if (item.mode === "CUSTOM" || item.model === "custom") {
                data = {
                  model: item.model,
                  name: item.name,
                  url: item.url,
                  account: item.account,
                  password: item.password,
                  lockAccount: item.lockAccount
                };
              } else {
                data = {
                  model: item.model,
                  id: item.id,
                  account: item.account,
                  password: item.password,
                  lockAccount: item.lockAccount
                };
              }
              arr.push(data);
            }
            return {
              extEbusinessPlatforms: arr
            };
          }
        })()), (() => {
          if (this.is_from_vd) {
            return {
              vdId: this.vd_id
            };
          }
        })());
        if (this.is_create === false) {
          url = `api://base.auth.pro/v1/shops/${this.shopId}`;
          submitData.model = "shop.edit";
          if (this.is_from_vd) {
            try {
              let edit_response = yield API.post(
                `api://base.auth.pro/v1/virtual-desktops/${this.vd_id}/shops-ebusiness-repeat`,
                {
                  model: "shop.edit",
                  shopId: this.shopId,
                  platformId: this._controller.form.platform_id
                }
              );
              if (edit_response.data.datas && edit_response.data.datas.length > 0) {
                try {
                  let message = "";
                  for (const ebusinessItem of edit_response.data.datas) {
                    if (ebusinessItem.total !== 0) {
                      message += `${this.$t("vdbindshop.bind_shop_confirm_tip", {
                        num: ebusinessItem.total,
                        custom: ebusinessItem.ebusinessName
                      })} ${this.$t(
                        `virtualdesktopform.bind_shop_confirm_bind_shop`,
                        { custom: ebusinessItem.ebusinessName }
                      )}`;
                    }
                  }
                  if (message !== "") {
                    yield this.$confirm(
                      message,
                      this.$t("vdbindshop.binding_shop_confirm_title"),
                      {
                        roundButton: true,
                        cancelButtonText: `${this.$t(
                          "vdbindshop.binding_tip_cancel"
                        )}`,
                        confirmButtonText: `${this.$t(
                          "vdbindshop.binding_tip_confirm"
                        )}`
                      }
                    );
                  }
                } catch (error) {
                  this.status = "ready";
                  return;
                }
              }
              if (this.open_high_setting_flag) {
                try {
                  yield this.$confirm(
                    this.$t("vdform.high_setting_confirm_content"),
                    this.$t("vdform.high_setting_confirm_title"),
                    {
                      roundButton: true,
                      showCancelButton: false,
                      confirmButtonText: this.$t(
                        "vdform.high_setting_confirm_button"
                      )
                    }
                  );
                } catch (error) {
                }
              }
              if (this.$session.marks.is("SECURITY_TRANSFER")) {
                const encry_data = this.rsaEncrypt.encrypt(submitData);
                if (encry_data.flag === true) {
                  const requestData = {
                    encrypted_data: encry_data.data
                  };
                  yield API.put(url, requestData);
                } else {
                  yield API.put(url, encry_data.data);
                }
              } else {
                yield API.put(url, submitData);
              }
            } catch (error) {
              if (this.open_high_setting_flag) {
                try {
                  yield this.$confirm(
                    this.$t("vdform.high_setting_confirm_content"),
                    this.$t("vdform.high_setting_confirm_title"),
                    {
                      roundButton: true,
                      showCancelButton: false,
                      confirmButtonText: this.$t(
                        "vdform.high_setting_confirm_button"
                      )
                    }
                  );
                } catch (error2) {
                }
              }
              if (this.$session.marks.is("SECURITY_TRANSFER")) {
                const encry_data = this.rsaEncrypt.encrypt(submitData);
                if (encry_data.flag === true) {
                  const requestData = {
                    encrypted_data: encry_data.data
                  };
                  yield API.put(url, requestData);
                } else {
                  yield API.put(url, encry_data.data);
                }
              } else {
                yield API.put(url, submitData);
              }
            }
          } else {
            if (this.open_high_setting_flag) {
              try {
                yield this.$confirm(
                  this.$t("vdform.high_setting_confirm_content"),
                  this.$t("vdform.high_setting_confirm_title"),
                  {
                    roundButton: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t(
                      "vdform.high_setting_confirm_button"
                    )
                  }
                );
              } catch (error) {
              }
            }
            if (this.$session.marks.is("SECURITY_TRANSFER")) {
              const encry_data = this.rsaEncrypt.encrypt(submitData);
              if (encry_data.flag === true) {
                const requestData = {
                  encrypted_data: encry_data.data
                };
                yield API.put(url, requestData);
              } else {
                yield API.put(url, encry_data.data);
              }
            } else {
              yield API.put(url, submitData);
            }
          }
        } else {
          url = `api://base.auth.pro/v1/shops`;
          submitData.model = "shop.custom";
          if (this._envId !== "" && this._envId !== null && this._envId !== void 0) {
            submitData.model = "shop.from.env";
            submitData.envId = this._envId;
          }
          if (this.is_from_vd && !this.isCustom) {
            let create_response = yield API.post(
              `api://base.auth.pro/v1/virtual-desktops/${this.vd_id}/shops-ebusiness-repeat`,
              {
                model: "shop.create",
                platformId: submitData.ebusinessPlatform.id
              }
            );
            if (create_response.data.datas && create_response.data.datas.length > 0) {
              try {
                let message = "";
                for (const ebusinessItem of create_response.data.datas) {
                  if (ebusinessItem.total !== 0) {
                    message += `${this.$t("vdbindshop.bind_shop_confirm_tip", {
                      num: ebusinessItem.total,
                      custom: ebusinessItem.ebusinessName
                    })} ${this.$t(`virtualdesktopform.bind_shop_confirm_bind_shop`, {
                      custom: ebusinessItem.ebusinessName
                    })}`;
                  }
                }
                if (message !== "") {
                  yield this.$confirm(
                    message,
                    this.$t("vdbindshop.binding_shop_confirm_title"),
                    {
                      roundButton: true,
                      cancelButtonText: `${this.$t(
                        "vdbindshop.binding_tip_cancel"
                      )}`,
                      confirmButtonText: `${this.$t(
                        "vdbindshop.binding_tip_confirm"
                      )}`
                    }
                  );
                }
              } catch (error) {
                if (this.is_create && this.import_cookies !== null && this.import_cookies !== "" && this._controller.form.cookie_mode !== "SHOP_COOKIE_NOSYNC") {
                  this.import_cookies = null;
                  this.real_import_cookies = null;
                }
                this.status = "ready";
                return;
              }
            }
          }
          if (this.$session.marks.is("SECURITY_TRANSFER")) {
            console.log(submitData);
            const encry_data = this.rsaEncrypt.encrypt(submitData);
            if (encry_data.flag === true) {
              const requestData = {
                encrypted_data: encry_data.data
              };
              yield API.post(url, requestData);
            } else {
              yield API.post(url, encry_data.data);
            }
          } else {
            yield API.post(url, submitData);
          }
        }
        if (this.import_cookies !== null && this.import_cookies !== "" && this._controller.form.cookie_mode !== "SHOP_COOKIE_NOSYNC") {
          this.import_cookies = null;
          this.real_import_cookies = null;
        }
        this.status = "ready";
        this.$emit("success");
        this._controller.dialog.visible = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
        this.status = "ready";
      }
    });
  }
};
__decorateClass([
  PropSync("controller", {
    type: VirtualDesktopController,
    default: function() {
      return new VirtualDesktopController();
    }
  })
], VirtualDesktopFormDialog.prototype, "_controller", 2);
__decorateClass([
  PropSync("env_id", {
    type: String,
    default: function() {
      return "";
    }
  })
], VirtualDesktopFormDialog.prototype, "_envId", 2);
__decorateClass([
  Ref("edittotpnamedialog")
], VirtualDesktopFormDialog.prototype, "_edittotpnamedialog", 2);
__decorateClass([
  Ref("fileUpload")
], VirtualDesktopFormDialog.prototype, "_fileUpload", 2);
__decorateClass([
  Ref("shopChooseUsers")
], VirtualDesktopFormDialog.prototype, "_shopChooseUsers", 2);
__decorateClass([
  Ref("shop-platform")
], VirtualDesktopFormDialog.prototype, "_shopPlatform", 2);
__decorateClass([
  Ref("add-visit-dialog")
], VirtualDesktopFormDialog.prototype, "_addVisitDialog", 2);
__decorateClass([
  Ref("configTotpDialog")
], VirtualDesktopFormDialog.prototype, "_configTotpDialog", 2);
__decorateClass([
  Ref("addtotpdialog")
], VirtualDesktopFormDialog.prototype, "_addtotpdialog", 2);
__decorateClass([
  Ref("bindtotpbylistdialog")
], VirtualDesktopFormDialog.prototype, "_bindtotpbylistdialog", 2);
__decorateClass([
  Ref("totpblacklistdialog")
], VirtualDesktopFormDialog.prototype, "_totpblacklistdialog", 2);
__decorateClass([
  Watch("uploadManager.queueTask")
], VirtualDesktopFormDialog.prototype, "onUploadManagerQueueTaskChange", 1);
__decorateClass([
  Watch("uploadManager.errorPrompt")
], VirtualDesktopFormDialog.prototype, "uploadErrorprompt", 1);
__decorateClass([
  Watch("uploadManager.isOverSize")
], VirtualDesktopFormDialog.prototype, "isOverSizePrompt", 1);
__decorateClass([
  Watch("uploadManager.isMaxSize")
], VirtualDesktopFormDialog.prototype, "isMaxSizePrompt", 1);
__decorateClass([
  Watch("uploadManager.refreshFileList")
], VirtualDesktopFormDialog.prototype, "refreshFileList", 1);
VirtualDesktopFormDialog = __decorateClass([
  Component({
    components: {
      ShopPlatforms,
      PasswordInput,
      UiSubmit,
      Question,
      UiDialog,
      UiForm,
      AccountSessionMixins,
      ShopChooseUsers,
      UploadEnclosure,
      UploadEnclosureBottom,
      ItemShop,
      AddVisitDialog,
      ConfigTOTPDialog,
      EditTOTPNameDialog,
      AddTOTPDialog,
      BindTOTPByListDialog,
      TOTPBlackListDialog
    }
  })
], VirtualDesktopFormDialog);
export {
  VirtualDesktopFormDialog as default
};
